import React from 'react';
import { AnimatedRoute as Scene } from '../../components/AnimatedRouter';
import { IRoute } from './IRoute';

export const generateRoutes = (routes: IRoute[], actionSelector?: any) =>
  actionSelector
    ? routes.map(route => (
        <Scene
          {...route}
          actions={
            route && route.actions && route.actions.length > 0
              ? actionSelector(...route.actions)
              : actionSelector()
          }
        >
          {route.children && generateRoutes(route.children, actionSelector)}
        </Scene>
      ))
    : routes.map((route: IRoute) => (
        <Scene {...route}>{route.children && generateRoutes(route.children, actionSelector)}</Scene>
      ));
